<script lang="ts" setup>
  import { computed, reactive, ref } from 'vue'
  import { vMaska } from 'maska'
  import { TEST_ID } from './CounterInput.constants'
  import { DEFAULT_MAX_LENGTH, INPUT_MASK_TOKEN } from '../../BaseCounterInput.constants'

  interface Props {
    modelValue: number
    maxLength?: number
  }
  interface Emits {
    (e: 'update:modelValue', value: number): void
    (e: 'change', value: number): void
  }

  const props = withDefaults(defineProps<Props>(), {
    maxLength: DEFAULT_MAX_LENGTH,
  })

  const emit = defineEmits<Emits>()

  const input = ref<HTMLInputElement>()
  const value = computed<number>({
    get() {
      return props.modelValue
    },
    set(newValue: number) {
      emit('update:modelValue', Number(newValue))
    },
  })

  const onChange = (event: Event) => {
    const target = event.target
    if (target instanceof HTMLInputElement) emit('change', Number(target.value))
  }

  const onInput = (event: Event) => {
    const target = event.target
    if (target instanceof HTMLInputElement) value.value = Number(target.value)
  }

  const maskOptions = reactive({
    tokens: { '#': { pattern: INPUT_MASK_TOKEN } },
    mask: '#'.repeat(props.maxLength),
  })
</script>

<template>
  <!-- TODO: Type should be number -->
  <!-- @vue-ignore -->
  <input
    ref="input"
    v-maska:[maskOptions]
    :value="value"
    class="counter-input"
    type="text"
    placeholder="0"
    inputmode="decimal"
    :maxlength="maxLength"
    :data-testid="TEST_ID"
    disabled
    @change="onChange"
    @input="onInput"
  />
</template>

<style scoped lang="scss">
  @import './CounterInput';
</style>
